import { apiRequest } from './http';
import { env } from '../config/env';
import type { LogItem } from '../types/api';

interface LogUploadResponse {
  status?: string;
  message?: string;
  code?: number;
}

// POST display logs to the report endpoint (absolute URL).
export async function uploadLogs(logs: LogItem[]): Promise<void> {
  const res = await apiRequest<LogUploadResponse>('', {
    method: 'POST',
    body: { logs },
    absoluteUrl: env.reportUrl,
  });
  // Report endpoint returns { status: "success" } or { code: 200 }.
  if (res.status && res.status !== 'success' && res.code !== 200) {
    throw new Error(res.message ?? 'Log upload failed.');
  }
}
